import React, { useEffect } from 'react';

export function useHandleCloseDrawer(ref: React.RefObject<any>, onClose: ()=> void) {
  useEffect(() => {
    const handleCloseDrawer = (e: MouseEvent) => {
      const el = e.target;
      if (el instanceof Node && !ref.current?.contains(el)) onClose();
    };

    window.addEventListener('click', handleCloseDrawer);

    return () => window.removeEventListener('click', handleCloseDrawer);
  }, [ref, onClose]);
}
